<script>
    import BrandImage from "@xd/components/BrandImage";

    export default {
        name: "BrandProductUrbanLite",
        components: { BrandImage },
        props: {
            product: Object,
            visibleElements: Array,
        },
        methods: {
            checkElement(index) {
                return !this.visibleElements.includes(index.toString());
            },
        },
    };
</script>

<template>
    <div class="brand-product" :id="product.slug">
        <div class="l-container">
            <div
                class="brand-product__blur"
                :class="{ 'is-animated': checkElement('blur') }"
                data-name="blur"
            >
                <img src="/static/xd-design/brand-history/blur.svg" alt="" />
            </div>

            <svg
                class="brand-product__line is-mobile"
                :class="{ 'is-animated': checkElement('line-mobile') }"
                data-name="line-mobile"
                width="66"
                height="56"
                viewBox="0 0 66 56"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="m1 1 64 54" stroke="#182028" stroke-width=".5" />
            </svg>

            <svg
                class="brand-product__line is-desktop"
                :class="{ 'is-animated': checkElement('line-desktop') }"
                data-name="line-desktop"
                width="365"
                height="125"
                viewBox="0 0 365 125"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="m1 1 364 123" stroke="#000" />
            </svg>

            <header class="brand-product__header">
                <div
                    class="brand-product__title"
                    :class="{ 'is-animated': checkElement('title') }"
                    data-name="title"
                >
                    {{ product.title }}
                </div>
                <div
                    class="brand-product__date"
                    :class="{ 'is-animated': checkElement('date') }"
                    data-name="date"
                >
                    {{ product.date }}
                </div>
            </header>

            <div class="brand-product__body">
                <div class="brand-product__col">
                    <div class="brand-product__info">
                        <div
                            class="brand-product__text text-1"
                            :class="{ 'is-animated': checkElement('text-1') }"
                            data-name="text-1"
                            v-html="product.text[0]"
                        ></div>
                        <div
                            class="brand-product__text text-2"
                            :class="{ 'is-animated': checkElement('text-2') }"
                            data-name="text-2"
                            v-html="product.text[1]"
                        ></div>
                        <div
                            class="brand-product__text text-3"
                            :class="{ 'is-animated': checkElement('text-3') }"
                            data-name="text-3"
                            v-html="product.text[2]"
                        ></div>
                    </div>

                    <div class="brand-product__image image-1">
                        <brand-image
                            :image="product.image"
                            :is-animated="checkElement('image-1')"
                            data-name="image-1"
                            index="1"
                        ></brand-image>
                    </div>
                </div>
                <div class="brand-product__col">
                    <div class="brand-product__image image-2">
                        <brand-image
                            :image="product.image"
                            :is-animated="checkElement('image-2')"
                            data-name="image-2"
                            index="2"
                        ></brand-image>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .brand-product {
        padding: 100px 16px 10px;
        @include bp($bp-desktop-sm) {
            padding: 100px 0 150px;
        }
    }

    .brand-product__header {
        margin-bottom: 40px;
        @include bp($bp-desktop-lg) {
            margin-bottom: 80px;
        }
    }

    .brand-product__body {
        @include bp($bp-desktop-lg) {
            display: flex;
            margin: 0 -40px;
        }
    }

    .brand-product__col {
        @include bp($bp-desktop-lg) {
            flex-grow: 1;
            margin: 0 40px;
            &:first-child {
                flex-basis: 524px;
                max-width: 524px;
            }
        }
    }

    .brand-product__image {
        &.image-1 {
            max-width: 96.28%;
            margin-left: -32px;
            margin-bottom: 40px;
            &::before {
                padding-bottom: 105.2%;
            }
            @include bp($bp-desktop-lg) {
                max-width: 524px;
                margin-left: 0;
                margin-bottom: 0;
            }
        }

        &.image-2 {
            width: calc(100% + 32px);
            margin-right: -32px;
            &::before {
                padding-bottom: 99%;
            }
            @include bp($bp-desktop-lg) {
                max-width: 656px;
                margin-right: 0;
            }
        }
    }

    .brand-product__info {
        margin-bottom: 40px;
        @include bp($bp-desktop-lg) {
            max-width: 460px;
            margin-bottom: 155px;
        }
    }

    .brand-product__text {
        margin-bottom: 16px;
        @include bp($bp-desktop-lg) {
            margin-bottom: 24px;
        }
    }

    .brand-product__line {
        top: 70px;
        right: -32px;
        stroke-dashoffset: 0;
        stroke-dasharray: 84;
        transition: all 0.7s ease-in;
        animation-duration: 4.5s;
        animation-delay: 1.7s;
        &.is-animated {
            stroke-dashoffset: 84;
        }
        @include bp($bp-desktop-lg) {
            top: 820px;
            right: -100px;
            stroke-dasharray: 385;
            &.is-animated {
                stroke-dashoffset: 385;
            }
        }
    }

    .brand-product__blur {
        @include box(189px);
        top: 300px;
        right: -16px;
        @include bp($bp-desktop-lg) {
            right: auto;
            top: auto;
            left: -190px;
            bottom: -125px;
            @include box(334px);
        }
    }
</style>
